<template>
    <div class="float-left">
        <b-button-group class="float-right">
            <b-button
                variant="success"
                @click="abrirModal()"
                v-if="$temAcessoView('CONV-00') && convenio.idSituacaoConvenio != 9"
                >Adicionar
            </b-button>
        </b-button-group>
        <prestacao-contas-mensal-form
            :mostrarModal="mostrarModal"
            :erros="erros"
            operacao="I"
            @fecharModal="fecharModal()"
            @salvar="salvar"
        ></prestacao-contas-mensal-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import PrestacaoContasMensalForm from './PrestacaoContasMensalForm'

export default {
    props: {
        convenio: { type: Object },
        desativarBotao: { type: Boolean }
    },

    components: {
        PrestacaoContasMensalForm
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(prestacaoInserida) {
            this.$store.dispatch('addRequest')
            let prestacaoInseridaDto = {
                idConvenio: this.$route.params.convenioId,
                dtCompetencia: this.$moment(
                    '01/' + prestacaoInserida.dtCompetencia,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD'),
                dtPrestacao: this.$moment(
                    prestacaoInserida.dtPrestacao,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD'),
                nuReceitasDiversas: prestacaoInserida.nuReceitasDiversas,
                nuTotalGasto: prestacaoInserida.nuTotalGasto,
                nuTotalRendimentos: prestacaoInserida.nuTotalRendimentos
            }
            ConveniosServicos.inserirPrestacaoContasMensal(
                prestacaoInseridaDto
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>

